import React from 'react';
import './Alert.css';

export default ({ title = '' }) => <div>Hellooooo</div>;
